
export * from '../../object-js-components-web/__liferay__/index.js';
